import type { components } from "#/schema";

// Type-safe array of sociaalEmotioneelThema field names that must exist in the schema
export const sociaalEmotioneelThemaFields = [
  "sociaalEmotioneelThemaEenTwee",
  "sociaalEmotioneelThemaDrieVier",
  "sociaalEmotioneelThemaVijfZes",
  "sociaalEmotioneelThemaZevenAcht",
] as const satisfies ReadonlyArray<
  keyof Pick<
    components["schemas"]["SociaalEmotioneelThemasReeksDetailModel"],
    | "sociaalEmotioneelThemaEenTwee"
    | "sociaalEmotioneelThemaDrieVier"
    | "sociaalEmotioneelThemaVijfZes"
    | "sociaalEmotioneelThemaZevenAcht"
  >
>;

// Type-safe array of LeerjaarCombo values excluding "None"
export const leerJaarComboWithoutNone = [
  "EenTwee",
  "DrieVier",
  "VijfZes",
  "ZevenAcht",
] as const satisfies ReadonlyArray<Exclude<components["schemas"]["LeerjaarCombo"], "None">>;

// Type derived from the const array
export type SociaalEmotioneelThemaFieldNames = (typeof sociaalEmotioneelThemaFields)[number];

// When creating a new sociaal-emotioneel thema, the domein should be undefined
// so the user explicitly has to choose a domein
export interface CrudSociaalEmotioneelThemasReeksDetailModel extends Omit<
  components["schemas"]["SociaalEmotioneelThemasReeksDetailModel"],
  "domein"
> {
  // Default domein is undefined
  domein?: components["schemas"]["SociaalEmotioneelDomein"];
}
